module.exports = __webpack_public_path__ + "static/media/close.7ee5377f.svg";